import React from 'react';
import { Upload, X } from 'lucide-react';

interface BulkImportHeaderProps {
  onClose: () => void;
}

export const BulkImportHeader: React.FC<BulkImportHeaderProps> = ({ onClose }) => {
  return (
    <div className="px-4 py-3 sm:px-6 sm:py-4 border-b border-slate-100 flex items-center justify-between bg-slate-50/50">
      <div className="flex items-center gap-2 sm:gap-2.5">
        <div className="w-8 h-8 sm:w-9 h-9 rounded-xl bg-indigo-50 border border-indigo-100 flex items-center justify-center shrink-0">
          <Upload className="w-4 h-4 sm:w-5 h-5 text-indigo-600" />
        </div>
        <div>
          <h2 className="text-sm sm:text-lg font-bold text-slate-900 tracking-tight">
            Impor Massal Katalog Buku (CSV)
          </h2>
          <p className="text-[10px] sm:text-xs text-slate-500">
            Daftarkan banyak buku sekaligus dengan mengunggah spreadsheet CSV.
          </p>
        </div>
      </div>
      <button
        onClick={onClose}
        className="w-8 h-8 rounded-lg text-slate-400 hover:text-slate-600 hover:bg-slate-100 flex items-center justify-center transition shrink-0 cursor-pointer"
        aria-label="Tutup Modal"
      >
        <X className="w-5 h-5" />
      </button>
    </div>
  );
};
